import {
  statisticsPerson,
  statisticsPersonMonth,
  statisticsPersonQuarter,
  statisticsPersonYear,
  statisticsGroup,
  statisticsGroupMonth,
  statisticsGroupQuarter,
  statisticsGroupYear
} from '@/api/renewreportserv'

export default {
  state: {
    state_RenewReport_StatisticsPersonResult: null,
    state_RenewReport_StatisticsPersonMonthResult: null,
    state_RenewReport_StatisticsPersonQuarterResult: null,
    state_RenewReport_StatisticsPersonYearResult: null,
    state_RenewReport_StatisticsGroupResult: null,
    state_RenewReport_StatisticsGroupMonthResult: null,
    state_RenewReport_StatisticsGroupQuarterResult: null,
    state_RenewReport_StatisticsGroupYearResult: null
  },
  mutations: {
    SET_RENEWREPORT_STATISTICSPERSON_RESULT: (state, rst) => {
      state.state_RenewReport_StatisticsPersonResult = rst
    },
    SET_RENEWREPORT_STATISTICSPERSONMONTH_RESULT: (state, rst) => {
      state.state_RenewReport_StatisticsPersonMonthResult = rst
    },
    SET_RENEWREPORT_STATISTICSPERSONQUARTER_RESULT: (state, rst) => {
      state.state_RenewReport_StatisticsPersonQuarterResult = rst
    },
    SET_RENEWREPORT_STATISTICSPERSONYEAR_RESULT: (state, rst) => {
      state.state_RenewReport_StatisticsPersonYearResult = rst
    },
    SET_RENEWREPORT_STATISTICSGROUP_RESULT: (state, rst) => {
      state.state_RenewReport_StatisticsGroupResult = rst
    },
    SET_RENEWREPORT_STATISTICSGROUPMONTH_RESULT: (state, rst) => {
      state.state_RenewReport_StatisticsGroupMonthResult = rst
    },
    SET_RENEWREPORT_STATISTICSGROUPQUARTER_RESULT: (state, rst) => {
      state.state_RenewReport_StatisticsGroupQuarterResult = rst
    },
    SET_RENEWREPORT_STATISTICSGROUPYEAR_RESULT: (state, rst) => {
      state.state_RenewReport_StatisticsGroupYearResult = rst
    }
  },
  actions: {
    RenewReportServ_StatisticsPerson ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsPerson(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_RENEWREPORT_STATISTICSPERSON_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_RENEWREPORT_STATISTICSPERSON_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RenewReportServ_StatisticsPersonMonth ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsPersonMonth(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_RENEWREPORT_STATISTICSPERSONMONTH_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_RENEWREPORT_STATISTICSPERSONMONTH_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RenewReportServ_StatisticsPersonQuarter ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsPersonQuarter(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_RENEWREPORT_STATISTICSPERSONQUARTER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_RENEWREPORT_STATISTICSPERSONQUARTER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RenewReportServ_StatisticsPersonYear ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsPersonYear(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_RENEWREPORT_STATISTICSPERSONYEAR_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_RENEWREPORT_STATISTICSPERSONYEAR_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RenewReportServ_StatisticsGroup ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsGroup(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_RENEWREPORT_STATISTICSGROUP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_RENEWREPORT_STATISTICSGROUP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RenewReportServ_StatisticsGroupMonth ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsGroupMonth(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_RENEWREPORT_STATISTICSGROUPMONTH_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_RENEWREPORT_STATISTICSGROUPMONTH_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RenewReportServ_StatisticsGroupQuarter ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsGroupQuarter(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_RENEWREPORT_STATISTICSGROUPQUARTER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_RENEWREPORT_STATISTICSGROUPQUARTER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    RenewReportServ_StatisticsGroupYear ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsGroupYear(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_RENEWREPORT_STATISTICSGROUPYEAR_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_RENEWREPORT_STATISTICSGROUPYEAR_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_RenewReport_StatisticsPersonResult: state => {
      return state.state_RenewReport_StatisticsPersonResult
    },
    get_RenewReport_StatisticsPersonMonthResult: state => {
      return state.state_RenewReport_StatisticsPersonMonthResult
    },
    get_RenewReport_StatisticsPersonQuarterResult: state => {
      return state.state_RenewReport_StatisticsPersonQuarterResult
    },
    get_RenewReport_StatisticsPersonYearResult: state => {
      return state.state_RenewReport_StatisticsPersonYearResult
    },
    get_RenewReport_StatisticsGroupResult: state => {
      return state.state_RenewReport_StatisticsGroupResult
    },
    get_RenewReport_StatisticsGroupMonthResult: state => {
      return state.state_RenewReport_StatisticsGroupMonthResult
    },
    get_RenewReport_StatisticsGroupQuarterResult: state => {
      return state.state_RenewReport_StatisticsGroupQuarterResult
    },
    get_RenewReport_StatisticsGroupYearResult: state => {
      return state.state_RenewReport_StatisticsGroupYearResult
    }
  }
}
